import { vuexHandbook } from '@/store/composition/handbook'
import TechBrandApi from '@/api/handbook/TechBrand/TechBrandApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: TechBrandApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
